/**
 * Two Sense — Glass effect mixins.
 *
 * Two finishes: "frosted" (heavy blur, more opaque, used over busy backgrounds
 * like the map or hero video) and "crystal" (subtle blur, near-transparent,
 * used to add a whisper of depth on top of clean cream/white surfaces).
 *
 * Each finish has a light variant (sits over light/cream backgrounds, surface
 * tint = white) and a dark variant (sits over dark/photo backgrounds, surface
 * tint = black).
 *
 * Usage:
 *   <Box sx={{ ...glass.frostedLight, p: 4 }}>...</Box>
 */

const FROSTED_BLUR = "blur(22px) saturate(1.4)";
const CRYSTAL_BLUR = "blur(8px) saturate(1.15)";

/* Soft, brand-neutral inner highlight that gives the edge a glass-like
   reflection without leaning warm or cool. */
const HIGHLIGHT_LIGHT =
    "inset 0 1px 0 rgba(255, 255, 255, 0.65), inset 0 -1px 0 rgba(0, 0, 0, 0.04)";
const HIGHLIGHT_DARK =
    "inset 0 1px 0 rgba(255, 255, 255, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.25)";

const frostedLight = {
    background: "rgba(255, 255, 255, 0.72)",
    backdropFilter: FROSTED_BLUR,
    WebkitBackdropFilter: FROSTED_BLUR,
    border: "1px solid rgba(255, 255, 255, 0.55)",
    boxShadow: `${HIGHLIGHT_LIGHT}, 0 24px 60px rgba(0, 0, 0, 0.08)`,
};

const frostedDark = {
    background: "rgba(0, 0, 0, 0.55)",
    backdropFilter: FROSTED_BLUR,
    WebkitBackdropFilter: FROSTED_BLUR,
    border: "1px solid rgba(255, 255, 255, 0.12)",
    boxShadow: `${HIGHLIGHT_DARK}, 0 30px 70px rgba(0, 0, 0, 0.4)`,
};

const crystalLight = {
    background: "rgba(255, 255, 255, 0.4)",
    backdropFilter: CRYSTAL_BLUR,
    WebkitBackdropFilter: CRYSTAL_BLUR,
    border: "1px solid rgba(255, 255, 255, 0.6)",
    boxShadow: HIGHLIGHT_LIGHT,
};

const crystalDark = {
    background: "rgba(0, 0, 0, 0.28)",
    backdropFilter: CRYSTAL_BLUR,
    WebkitBackdropFilter: CRYSTAL_BLUR,
    border: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: HIGHLIGHT_DARK,
};

const glass = {
    frostedLight,
    frostedDark,
    crystalLight,
    crystalDark,
};

export default glass;
export { frostedLight, frostedDark, crystalLight, crystalDark };
